module.exports = __webpack_public_path__ + "img/sparkly_btc.e236082f.svg";